import { Component } from '@angular/core';
import { SettingsService, SyncSettings, SyncSettingsPostPayload } from '@app/shared/services/settings/settings.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  templateUrl: './settings-sync.component.html',
  styleUrls: ['./settings-sync.component.scss'],
})
export class SettingsSyncComponent {
  saveStatus: number = 0;

  syncSettings$: Observable<SyncSettings[]>;

  properties: any[];

  constructor(private settingsService: SettingsService) {
    this.syncSettings$ = this.settingsService.getSyncSettings();
  }

  saveChanges(settings: SyncSettings[]) {
    const payload: SyncSettingsPostPayload = {};

    Object.keys(settings).forEach((item) => {
      let key = settings[item].key;
      let value = settings[item].value;

      payload[key] = value;
    });

    this.saveStatus = 1;

    this.settingsService.saveSyncSettings(payload).subscribe((res) => {
      this.saveStatus = 2;

      setTimeout(() => {
        this.saveStatus = 0;
      }, 2000);
    });
  }
}
